// Local library
import { AccountFacade } from '@amwager/account/data-access';
import { UnsubscribeObservableService } from '@amwager/util';

// Angular libray
import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit
} from '@angular/core';

// Third party
import { Subscription, takeUntil } from 'rxjs';

@Component({
  selector: 'feature-ion-wagering-preferences',
  templateUrl: './wagering-preferences.component.html',
  styleUrls: ['./wagering-preferences.component.scss'],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class WageringPreferencesComponent extends UnsubscribeObservableService implements OnInit {

  private subsGetAccountPreferenceResponse!: Subscription;

  sortBy!: string;
  isClearWager!: boolean;
  requireConfirmation!: boolean;
  eventTypeFilter!: string[];
  eventTypeFilterCopy: string[] = [];
  isExoticSelections!: boolean;
  showHandicapperIcons!: boolean;

  eventTypes: string[] = [
    'thoroughbred',
    'harness',
    'greyhound',
    'international'
  ];

  fields = {
    fieldName: '',
    value: ''
  }

  isDisabled: boolean = false;

  constructor(
    private readonly accountFacade: AccountFacade,
    private readonly elementRef: ElementRef,
    private readonly cdRef: ChangeDetectorRef,
  ) {
    super();

  }

  ngOnInit() {
    // update branch
    this.accountFacade.getAccountPreferencesAPI();
    this.subsGetAccountPreferenceResponse = this.accountFacade.isGetAccountPreferencesSuccess$()
      .pipe(takeUntil(this.toUnsubscribe$))
      .subscribe((callback) => {

        if (callback?.isSuccess === undefined) return;

        const response = callback?.response?.AccountPreferences;

        this.sortBy = response?.SortBy;
        this.isClearWager = response?.IsClearWager;
        this.requireConfirmation = response?.RequireConfirmation;
        this.isExoticSelections = response?.IsExoticSelections;
        this.eventTypeFilter = response?.EventTypeFilter;
        this.showHandicapperIcons = response?.ShowHandicapperIcons;

        this.isDisabled = false;
        this.eventTypeFilterCopy = [...this.eventTypeFilter];
        // console.log(callback);

        // this.subsGetAccountPreferenceResponse?.unsubscribe();
        this.cdRef.markForCheck();
      });
  }

  setPreference(value: string): void {

    if (this.isDisabled) return;

    if (this.eventTypes.includes(value)) {
      if (
        this.eventTypeFilterCopy.length === 1 &&
        this.eventTypeFilterCopy.indexOf(
          value[0].toUpperCase() + value.slice(1).toLowerCase()
        ) > -1 &&
        value !== 'thoroughbred'
      ) return;
      else if (
        this.eventTypeFilterCopy.length === 2 &&
        this.eventTypeFilterCopy.indexOf(
          value[0].toUpperCase() + value.slice(1).toLowerCase()
        ) > -1 &&
        value === 'thoroughbred')
        return;
    }

    this.getPreferenceAttr(value);
    this.accountFacade.upsertAccountPrefenceFieldAPI(this.fields.fieldName, this.fields.value);
  }

  getPreferenceAttr(type: string): void {

    switch (type) {
      case 'name':
        this.sortBy = 'Name';
        this.fields.fieldName = 'SortBy';
        this.fields.value = 'Name';
        break;

      case 'mtp':
        this.sortBy = 'MTP';
        this.fields.fieldName = 'SortBy';
        this.fields.value = 'MTP';
        break;

      case 'clean-on-wager':
        // this.isClearWager = !this.isClearWager;
        this.fields.fieldName = 'IsClearWager';
        this.fields.value = !this.isClearWager ? 'true' : 'false';
        break;

      case 'require-confirmation':
        // this.requireConfirmation = !this.requireConfirmation;
        this.fields.fieldName = 'RequireConfirmation';
        this.fields.value = !this.requireConfirmation ? 'true' : 'false';
        break;

      case 'keep-exotic-selections':
        // this.isExoticSelections = !this.isExoticSelections;
        this.fields.fieldName = 'IsExoticSelections';
        this.fields.value = !this.isExoticSelections ? 'true' : 'false';
        break;

      case 'show-handicapper-icons':
        // this.showHandicapperIcons = !this.showHandicapperIcons;
        this.fields.fieldName = 'ShowHandicapperIcons';
        this.fields.value = !this.showHandicapperIcons ? 'true' : 'false';
        break;

      // event types
      case 'thoroughbred':
        this.removeOrAddEventType('Thoroughbred');
        // this.removeOrAddEventType('Quarterhorse');
        this.fields.fieldName = 'EventTypeFilter';
        this.fields.value = JSON.stringify(this.eventTypeFilterCopy);
        // this.fields.value = JSON.stringify(this.eventTypeFilter);
        break;

      case 'harness':
        this.removeOrAddEventType('Harness');
        this.fields.fieldName = 'EventTypeFilter';
        this.fields.value = JSON.stringify(this.eventTypeFilterCopy);
        // this.fields.value = JSON.stringify(this.eventTypeFilter);
        break;

      case 'greyhound':
        this.removeOrAddEventType('Greyhound');
        this.fields.fieldName = 'EventTypeFilter';
        this.fields.value = JSON.stringify(this.eventTypeFilterCopy);
        // this.fields.value = JSON.stringify(this.eventTypeFilter);
        break;

      case 'international':
        this.removeOrAddEventType('International');
        this.fields.fieldName = 'EventTypeFilter';
        this.fields.value = JSON.stringify(this.eventTypeFilterCopy);
        // this.fields.value = JSON.stringify(this.eventTypeFilter);
        break;
    }

    this.isDisabled = true;

  }

  isEventTypeExists(eventType: string): boolean {
    if (this.eventTypeFilter === undefined)
      return false;
    else
      return this.eventTypeFilter.includes(eventType);
  }

  removeOrAddEventType(eventType: string): void {
    // this.eventTypeFilterCopy = [...this.eventTypeFilter];

    if (eventType === 'Thoroughbred') {
      this.toggleThoroughbredAndQuarterhorse();
    }
    else {
      const index = this.eventTypeFilterCopy.indexOf(eventType);
      if (index > -1) {
        this.eventTypeFilterCopy.splice(index, 1);
      }
      else {
        this.eventTypeFilterCopy.push(eventType);
      }
    }
  }

  toggleThoroughbredAndQuarterhorse(): void {
    const thoroughbredIndex = this.eventTypeFilterCopy.indexOf('Thoroughbred');
    const quarterhorseIndex = this.eventTypeFilterCopy.indexOf('Quarterhorse');

    if (thoroughbredIndex > -1 && quarterhorseIndex > -1) {

      this.eventTypeFilterCopy.splice(thoroughbredIndex, 1);
      this.eventTypeFilterCopy.splice(thoroughbredIndex, 1);
    }
    else {

      if (thoroughbredIndex === -1) {
        this.eventTypeFilterCopy.push('Thoroughbred');
      }
      if (quarterhorseIndex === -1) {
        this.eventTypeFilterCopy.push('Quarterhorse');
      }
    }
  }

}
